let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aLjnL")).then(() => parcelRequire('7a2zQ'));